// Shared CTA button classes for the platform marketing surface ("COMMERCE,
// PRINTED."). The look lives in globals.css under `.pf-btn*` (hard 2px ink
// border, pop-onto-a-solid-shadow hover) so it works in RSC with no JS;
// per-use metrics (padding, font-size) are passed inline at the call site.

/** Signal-orange solid — the primary "open your store" action. */
export const PF_BTN_ACCENT = "pf-btn pf-btn-accent";

/** Ink solid — header CTA and strong secondary actions on paper. */
export const PF_BTN_INK = "pf-btn pf-btn-ink";

/** Transparent with a border in the current ink — quiet secondary actions.
 *  On dark bands, wrap the section in `.pf-dark` so borders/shadows flip. */
export const PF_BTN_PAPER = "pf-btn pf-btn-paper";
